import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Congratulating from '@wellbeingxltd/fe-lib/images/dist/illustrations/Congratulating.svg'
import { AnalyticsActions } from 'store/models/analytics'
import { Button } from 'components'
import './styles.scss'

export const ConfirmOnboarding = () => {
    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        dispatch(AnalyticsActions.postAnalytics('[ConfirmOnboarding] componentDidMount', null))
    }, [])

    return (
        <div className="ConfirmOnboarding-container">
            <div className="content">
                <img src={Congratulating} alt="Congratulations" className="illustration" />
                <h1>Thank you!</h1>
                <p>You've successfully joined as a Betterspace supplier!</p>
                <p>
                    You're almost ready to receive orders from Betterspace users. We just need to add your resources to our directory, leave that with
                    us!
                </p>
                <p>
                    The next screen you'll see will be your dashboard. Here you'll be able to manage your orders, check your resources and modify your
                    manager and notification settings.
                </p>
            </div>
            <Button className="redirectButton" onClick={() => history.replace('transactions')} shape="round" size="large">
                Go To DASHBOARD
            </Button>
        </div>
    )
}
